import React from "react";
import { Row } from "reactstrap";
import BusyIndicator from "react-busy-indicator";
import { useLoadingRoute, NotFoundBoundary } from "react-navi";
import { Header } from "./header";

export function Layout({ children }) {
  const loadingRoute = useLoadingRoute();

  return (
    <React.Fragment>
      <Header />
      <Row className="col-md-12 mt-5 mb-5 d-flex justify-content-center" />
      <BusyIndicator isBusy={loadingRoute} delayMs={0} />
      {children}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/views/layout/layout.jsx